import $ from 'jquery';

const $preloader = $('.js-preloader');

export default () => {
	$preloader.addClass('preloader_loaded');
};



// WEBPACK FOOTER //
// ./app/blocks/preloader/preloader.js